import 'components/styles/singleSelectButton.scss';
import { isEmpty, map, noop, sortBy } from 'lodash';
import React, { Fragment } from "react";
import { useSetTranslation } from "common/useSetTranslation";

const getLabelStyle = (centerOptionText, showBorder, disabled) => ({
  justifyContent: centerOptionText ? 'center' : 'flex-start',
  textAlign: centerOptionText ? 'center' : 'left',
  display: 'inline-flex',
  alignItems: 'center',
  padding: '12px 20px',
  borderRadius: '6px',
  border: showBorder ?'1px solid #ddd' : 'none',
  cursor: disabled ? 'not-allowed' : 'pointer',
  boxShadow: showBorder
    ? '0 0 0 1px rgba(0,0,0,0.05)'
    : 'none',
  transition: 'all 0.2s ease-in-out',
  opacity: disabled ? 0.6 : 1,
  pointerEvents: disabled ? 'none' : 'auto',
});

const OptionItem = ({ option, handleChange, value, questionKey, centerOptionText, showBorder, disabled }) => {
  const { st } = useSetTranslation();
  const optionLabel = st(option.label, option.localeLabel);
  const answered = !isEmpty(value);
  const isSelected = (answer) => answered && answer.key === value.key;

  return (
    <Fragment>
      <input
        type="radio"
        id={optionLabel + "-" + questionKey}
        name={questionKey}
        value={option.key}
        checked={isSelected(option)}
        onChange={() => handleChange(option)}
        className={answered && "notSelected"}
        disabled={disabled}
      />
      <label
        htmlFor={optionLabel + "-" + questionKey}
        style={getLabelStyle(centerOptionText, showBorder, disabled)}
      >
        {optionLabel}
      </label>
    </Fragment>
  );
};

const SingleChoiceButton = ({
  onAnswered = noop,
  value,
  question: { answerOptions = [], key },
  centerOptionText = false,
  showBorder = false,
  disabled = false,
}) => {
  const orderedAnswerOptions = sortBy(answerOptions, (option) => option.displayOrder);

  const handleChange = (option) => {
    onAnswered(option);
  };

  return (
    <div className="radio-toolbar">
      {map(orderedAnswerOptions, (option) => (
        <OptionItem
          key={option.key}
          option={option}
          handleChange={handleChange}
          questionKey={key}
          value={value}
          centerOptionText={centerOptionText}
          showBorder={showBorder}
          disabled={disabled}
        />
      ))}
    </div>
  );
};

export default SingleChoiceButton;
